<template>
    <div>
        Nutzer in der Gruppe:
        <loading v-show="loadingUsers"></loading>
        <div v-for="u in this.sorted" v-show="!loadingUsers">
            <label>
                <input class="mr-2" type="checkbox" :value="u.id" v-model="selected">
                {{ u.first_name }} {{ u.name }}
            </label>
        </div>
    </div>
</template>

<script>
import Loading from "./UI/Loading.vue";

export default {
    name: "UserListSelection",
    components: {
        Loading
    },
    props: {
        value: {},
        users: {},
        loadingUsers: {
            value: false
        }
    },
    computed:{
        sorted(){
            this.users.sort((a,b) => (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : ((b.name.toLowerCase() > a.name.toLowerCase()) ? -1 : 0))

            return this.users;
        },
        selected: {
            set(value) {
                this.$emit('input', value);
            },
            get() {
                return this.value;
            },
        },
    }
}
</script>

<style scoped>

</style>
